module.exports = __webpack_public_path__ + "static/media/sn_tg.f06fe7b7.svg";